import React, { Component } from 'react';

import Header from '../components/HeaderSection/Header';
import HeroSection from '../components/HeroSection/HeroFive';
import FeatureSection from '../components/Features/FeatureFive';
import ServiceSection from '../components/ServiceSection/ServiceFive';
import Work from '../components/WorkSection/Work';
import ReviewSection from '../components/ReviewSection/ReviewTwo';
import Download from '../components/DownloadSection/Download';
import Team from '../components/TeamSection/Team';
import ContactSection from '../components/ContactSection/Contact';
import FooterSection from '../components/FooterSection/Footer';

class ThemeFive extends Component {
    render() {
        return (
            <div className="homepage-5">
                {/*====== Scroll To Top Area Start ======*/}
                <div id="scrollUp" title="Scroll To Top">
                    <i className="fas fa-arrow-up" />
                </div>
                {/*====== Scroll To Top Area End ======*/}
                <div className="main">
                    <Header imageData={"/img/logo-white.png"} />
                    <HeroSection />
                    <FeatureSection />
                    <Work />
                    <ServiceSection />
                    <Download />
                    <Team />
                    <ReviewSection />

                    <ContactSection  />
                    <FooterSection />
                </div>
            </div>
        );
    }
}

export default ThemeFive;